module.exports = __webpack_public_path__ + "img/p.ab361dda.png";